// Normal physical-exam findings, keyed by the predefined exam observation's
// label (observationCode.text). The "Fill normal exam" button charts these in
// one click. These labels are fixed on the backend; if they ever change, update
// this map to match.
export const NORMAL_EXAM_FINDINGS: Record<string, string> = {
  "Physical findings of General status Narrative":
    "Alert, no apparent distress",
  "Physical findings of Head Narrative":
    "Normocephalic, non-muffled voice, no visible abnormalities in oropharynx",
  "Physical findings of Thorax and Lungs Narrative":
    "Normal respiratory rate, no audible wheezing",
  "Physical findings of Skin Narrative": "No skin abnormalities noted",
  "Psychiatric findings Narrative":
    "Normal mood and affect, normal speech cadence",
  "Physical findings of Neurologic balance and Coordination Narrative":
    "No facial asymmetry, no slurring of speech, normal movement of bilateral upper extremities",
};
